import * as React from 'react'
import type { SVGProps } from 'react'
const SvgMastadon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.9683 17.2439c2.5059-.2993 4.6878-1.8433 4.9621-3.2541.4321-2.2224.3964-5.4235.3964-5.4235 0-4.3386-2.8426-5.6103-2.8426-5.6103-1.4332-.6583-3.8943-.9351-6.4512-.956h-.0628c-2.557.0209-5.0164.2977-6.4497.956 0 0-2.8427 1.2717-2.8427 5.6103 0 .263-.0014.5397-.0028.8277-.004.7998-.0083 1.6872.0149 2.6134.1032 4.243.7778 8.4246 4.7007 9.4629 1.8088.4788 3.3617.579 4.6124.5102 2.2682-.1257 3.5414-.8094 3.5414-.8094l-.0748-1.6457s-1.6208.5111-3.4411.4488c-1.8035-.0618-3.7074-.1945-3.9991-2.4087a4.54 4.54 0 0 1-.0404-.6209s1.7704.4328 4.014.5356c1.372.0629 2.6586-.0804 3.9653-.2363m2.0056-3.0877V8.9029c0-1.0737-.2733-1.927-.8223-2.5581-.5664-.6313-1.308-.9548-2.2284-.9548-1.0652 0-1.8717.4093-2.4049 1.2281l-.5185.869-.5184-.869C10.9481 5.7993 10.1416 5.39 9.0766 5.39c-.9206 0-1.6621.3235-2.2284.9548-.5491.6312-.8225 1.4844-.8225 2.558v5.2534H8.107v-5.099c0-1.0748.4522-1.6204 1.3568-1.6204 1.0002 0 1.5016.6472 1.5016 1.927v2.7909h2.069v-2.791c0-1.2797.5012-1.9268 1.5014-1.9268.9046 0 1.3569.5455 1.3569 1.6204v5.0989z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgMastadon
